<template>
  <v-container fill-height fluid :style="background">
    <v-card>
      <v-row align="center">
        <v-col cols="3">
          <v-container>
            <p class="text-h6 dark_green">
              Login using the same Google email you purchased the subscription
              with
            </p>
            <app-login></app-login>

            <p class="subtitle-1 dark_green mt-4">
              Not subscribed yet, subscribe here :<v-btn
                outlined
                color=""
                v-on:click="openUrl('https://pop-word.com')"
                >subscribe</v-btn
              >
            </p>
          </v-container>
        </v-col>
        <v-col cols="9">
          <v-carousel cycle hide-delimiter-background show-arrows-on-hover>
            <v-carousel-item v-for="(slide, i) in slides" :key="i">
              <v-img :src="slide"></v-img>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import LoginButton from "../components/LoginButton.vue";
import slide1 from "../assets/img/popword_slide1.png";
import slide2 from "../assets/img/popword_slide2.png";
import slide3 from "../assets/img/popword_slide3.png";
import popword_background from "../assets/img/popword_background.png";
export default {
  name: "Login",
  data() {
    return {
      //require("/../public/popword_slice3"), require("/../public/popword_slice31"), require("/../public/popword_slice4"), require("../../public/popword_slice5"), require("../../public/popword_slice6")
      slides: [slide1, slide2, slide3],
      background: { "background-image": `url(${popword_background})` },
    };
  },
  components: {
    "app-login": LoginButton,
  },
  methods:{
    openUrl(url){
      window.open(url)
    }
  }
};
</script>
<style scoped></style>
